import { showLobbyFormat } from 'components/SaloonLobby/showLobbyFormat';

import type { MultiRunIntroDismissReason } from './MultiRunIntroModal';

/**
 * BROWSE TABLES lands the player on the Cash tab, where the multi-run tables
 * are. The lobby is usually there already, but not always: a post-login
 * tournament resume opens it on Tournaments, and the introduction can wait for
 * a later lobby moment on any tab. Every other way out leaves the tab alone.
 */
export const followMultiRunIntroDismissal = (reason: MultiRunIntroDismissReason): void => {
  if (reason === 'browse-tables') showLobbyFormat('cash');
};
